import { Component, Input } from '@angular/core';
import { IconV2Module, DateV2Module } from '@schenck/rotec-components';

@Component({
  selector: 'ma-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.less'],
  imports: [IconV2Module, DateV2Module],
})
export class DateComponent {
  @Input() public date: Date | string | number;
  @Input() public dark: boolean = false;
  @Input() public isSelected: boolean;
}
